import t from "@ext/localization/locale/translate";
import type { ConfirmOptions } from "@ui-kit/ConfirmPopover";

const TEXTS = {
	local: { title: "catalog.delete.title", description: "catalog.delete.local" },
	storage: { title: "catalog.delete.title", description: "catalog.delete.storage" },
	device: { title: "catalog.delete.device.title", description: "catalog.delete.device.confirm" },
	space: { title: "catalog.delete.space.title", description: "catalog.delete.space.confirm" },
	"space-not-loaded": { title: "catalog.delete.space.title", description: "catalog.delete.space.confirm-not-loaded" },
} as const;

export type CatalogDeleteKind = keyof typeof TEXTS;

export const catalogDeleteConfirm = (kind: CatalogDeleteKind): ConfirmOptions => ({
	title: t(TEXTS[kind].title),
	description: t(TEXTS[kind].description),
	confirmText: t("delete"),
	status: kind === "device" ? "warning" : "error",
	icon: "triangle-alert",
});
